query hubspotUserIdentification {
  hubspotUserIdentification {
    email
    token
  }
}
